import { render, staticRenderFns } from "./BaseStationMetaSection.vue?vue&type=template&id=0fd4c9b0&scoped=true&"
import script from "./BaseStationMetaSection.vue?vue&type=script&lang=ts&"
export * from "./BaseStationMetaSection.vue?vue&type=script&lang=ts&"
import style0 from "./BaseStationMetaSection.vue?vue&type=style&index=0&id=0fd4c9b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd4c9b0",
  null
  
)

export default component.exports